/** This is ordered based on priority */
export const AvailableInfluencerBadges = [
  'top-media',
  'spotify-playlist',
  'youtube-channel',
  'impacting',
  'quality-feedbacks',
  'event-organizer',
  'high-answer-rate',
  'high-sharing-rate',
  'highly-selective',
] as const
